import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { LoadingSkeleton } from '@/components/LoadingSkeleton';
const PageDesigner = lazy(() => import('@/components/designer/PageDesigner'));
export const Route = createFileRoute('/sites/$siteSlug/pages/$pageId_/design')({ component: DesignPage });
function DesignPage() {
  const { siteSlug, pageId } = Route.useParams();
  return <Suspense fallback={<LoadingSkeleton />}><PageDesigner key={`${siteSlug}:${pageId}`} siteSlug={siteSlug} pageId={pageId} /></Suspense>;
}
